import { StationEvseStatus } from "src/modules/station/types/Station";
import { SessionStatus } from "./Session";

export enum WssSessionClassTypes {
    SESSION = "Session",
}

export enum WssSessionEventTypes {
    SESSION_STATUS = "session_status",
}

export interface WssSessionStatus {
    event: WssSessionEventTypes.SESSION_STATUS;
    class: WssSessionClassTypes.SESSION;
    id: string;
    status: SessionStatus;
    evseStatus?: StationEvseStatus;
    companyId: string;
}

export type WssSessionPayload = WssSessionStatus;
